import { forwardRef } from 'react'

export const TruckIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    width="24"
    height="17"
    viewBox="0 0 24 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M13.5298 13.2754H8.47321C8.28758 13.2754 8.13976 13.1276 8.13976 12.942C8.13976 12.7564 8.28758 12.6086 8.47321 12.6086H13.1964V1.66688H1.66688V12.612H3.85316C4.03878 12.612 4.1866 12.7598 4.1866 12.9454C4.1866 13.1311 4.03878 13.2789 3.85316 13.2789H1.33344C1.14781 13.2754 1 13.1276 1 12.9454V1.33344C1 1.14781 1.14781 1 1.33344 1H13.5298C13.7154 1 13.8633 1.14781 13.8633 1.33344V12.9454C13.8633 13.1276 13.7154 13.2754 13.5298 13.2754Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M15.9522 13.2754H13.5288C13.3431 13.2754 13.1953 13.1276 13.1953 12.942C13.1953 12.7563 13.3431 12.6085 13.5288 12.6085H15.9522C16.1378 12.6085 16.2857 12.7563 16.2857 12.942C16.2857 13.1276 16.1378 13.2754 15.9522 13.2754Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M22.6657 13.2754H20.5723C20.3866 13.2754 20.2388 13.1276 20.2388 12.942C20.2388 12.7563 20.3866 12.6085 20.5723 12.6085H22.3323V9.48379L18.5991 4.14186H13.5288C13.3431 4.14186 13.1953 3.99404 13.1953 3.80842C13.1953 3.62279 13.3431 3.47498 13.5288 3.47498H18.7744C18.8844 3.47498 18.9841 3.52654 19.046 3.61591L22.9407 9.1916C22.9785 9.2466 22.9992 9.31535 22.9992 9.3841V12.9454C22.9992 13.1276 22.8514 13.2754 22.6657 13.2754Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M19.5585 8.5214H15.3647C15.1791 8.5214 15.0312 8.37358 15.0312 8.18796V5.67512C15.0312 5.48949 15.1791 5.34167 15.3647 5.34167H18.0735C18.1732 5.34167 18.2694 5.38636 18.3347 5.46543L19.8232 7.31826C19.8713 7.3767 19.8954 7.45232 19.8954 7.52795V8.18796C19.8919 8.37015 19.7441 8.5214 19.5585 8.5214ZM15.6981 7.85451H19.2285V7.64482L17.9153 6.00856H15.7016V7.85451H15.6981Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M18.2642 16.0083C16.7895 16.0083 15.5898 14.8086 15.5898 13.3339C15.5898 13.1826 15.6036 13.0314 15.6277 12.887C15.8442 11.5945 16.9545 10.6595 18.2642 10.6595C19.5739 10.6595 20.6843 11.5979 20.9008 12.8904C20.9249 13.0348 20.9387 13.1861 20.9387 13.3373C20.9387 14.8086 19.739 16.0083 18.2642 16.0083ZM18.2642 11.3264C17.2811 11.3264 16.4458 12.0311 16.2842 13.0004C16.267 13.1104 16.2567 13.2204 16.2567 13.3339C16.2567 14.4408 17.1574 15.3414 18.2642 15.3414C19.3711 15.3414 20.2718 14.4408 20.2718 13.3339C20.2718 13.2204 20.2615 13.107 20.2443 13.0004C20.0793 12.0311 19.2474 11.3264 18.2642 11.3264Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M6.16464 16.0083C4.68994 16.0083 3.49023 14.8086 3.49023 13.3339C3.49023 13.1827 3.50398 13.0314 3.52805 12.887C3.74461 11.5945 4.85494 10.6595 6.16464 10.6595C7.47434 10.6595 8.58466 11.598 8.80123 12.8905C8.82529 13.0349 8.83904 13.1861 8.83904 13.3374C8.83904 14.8086 7.63934 16.0083 6.16464 16.0083ZM6.16464 11.3264C5.1815 11.3264 4.34618 12.0311 4.18462 13.0005C4.16743 13.1105 4.15712 13.2205 4.15712 13.3339C4.15712 14.4408 5.05775 15.3414 6.16464 15.3414C7.27153 15.3414 8.17216 14.4408 8.17216 13.3339C8.17216 13.2205 8.16185 13.107 8.14466 13.0005C7.9831 12.0311 7.14777 11.3264 6.16464 11.3264Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M18.2647 14.7983C17.4982 14.7983 16.876 14.1761 16.876 13.4095C16.876 12.6429 17.4982 12.0207 18.2647 12.0207C19.0313 12.0207 19.6535 12.6429 19.6535 13.4095C19.6535 14.1726 19.0313 14.7983 18.2647 14.7983ZM18.2647 12.6842C17.866 12.6842 17.5429 13.0073 17.5429 13.406C17.5429 13.8048 17.866 14.1279 18.2647 14.1279C18.6635 14.1279 18.9866 13.8048 18.9866 13.406C18.9866 13.0073 18.6635 12.6842 18.2647 12.6842Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M6.1622 14.7983C5.39563 14.7983 4.77344 14.1761 4.77344 13.4095C4.77344 12.6429 5.39563 12.0207 6.1622 12.0207C6.92877 12.0207 7.55097 12.6429 7.55097 13.4095C7.55097 14.1726 6.92877 14.7983 6.1622 14.7983ZM6.1622 12.6842C5.76345 12.6842 5.44032 13.0073 5.44032 13.406C5.44032 13.8048 5.76345 14.1279 6.1622 14.1279C6.56096 14.1279 6.88409 13.8048 6.88409 13.406C6.88409 13.0073 6.56096 12.6842 6.1622 12.6842Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
  </svg>
))

TruckIcon.displayName = 'TruckIcon'
